// extracted by mini-css-extract-plugin
module.exports = {"globalFooter":"globalFooter___dLqdB","links":"links___HFeXJ","copyright":"copyright___CqEmi"};